import React, { Component } from "react";
import { Tabs, Card } from "antd";
import BacklinksResults from "../../containers/Backlinks/BacklinksResults";

const { TabPane } = Tabs;

class BacklinksTabs extends Component {
  render() {
    return (
      <Card>
        <Tabs type="card" tabBarGutter={10}>
          {this.props.settings.map((tab, tab_idx) => {
            return (
              <TabPane tab={tab.label} key={`tab${tab_idx}`}>
                <BacklinksResults
                  domain={this.props.domain}
                  resourceType={tab.resource_type}
                  orderBy={tab.order_by}
                  orderDir={tab.order_dir}
                />
              </TabPane>
            );
          })}
        </Tabs>
      </Card>
    );
  }
}

export default BacklinksTabs;
